import { Grid, Typography, Box } from '@mui/material';
import React from 'react';
import MarkdownRenderer from '../../../components/MarkdownRenderer/index';

export function getArticleDetails(content) {
  const title = content.fields?.title?.replace(/article/i, '').trim() || 'Missing article title';
  const body = content.fields?.content || 'Missing article body';
  return {
    title,
    Body: () => (
      <Box sx={{ padding: '30px' }}>
        <Grid
          maxWidth="800px"
          margin="auto"
        >
          <Typography
            variant="h3"
            fontWeight="bold"
            margin="auto"
          >
            {title}
          </Typography>
        </Grid>
        <Grid
          maxWidth="800px"
          margin="auto"
        >
          <MarkdownRenderer markdownText={body} />
        </Grid>
      </Box>
    ),
  };
}
